


























































































































































































import Component, { mixins } from "vue-class-component";
import MobileMixin from "@/mixins/mobileMixin";
import { Enseigne } from "@/shared/Enseigne";
import { Watch } from "vue-property-decorator";
import { Societe } from "@/shared/Groupe";
import ErrorMixin from "@/mixins/errorMixins";
import VueJsonToCsv from "vue-json-to-csv";
import { Site } from "@/shared/Site";
import _ from "lodash";
import ConfigMixin from "@/mixins/ConfigMixin";

@Component({
  components: { VueJsonToCsv },
})
export default class Sites extends mixins(
  MobileMixin,
  ErrorMixin,
  ConfigMixin
) {
  public search: string = "";
  public selectedSociete: Societe = new Societe();
  public showToCreate: boolean = false;
  public filteredSocieties: any = {};
  public restaurantIds_to_enseigne: any = {};
  public restaurantIds_to_codeAlpha: any = {};

  public created() {
    this.resIdToCodeAlpha(this.restaurantIds_to_codeAlpha);
    this.resIdToEnseignes(this.restaurantIds_to_enseigne);
  }

  public getFilteredSocietes(): Societe[] {
    const socs = this.societes.filter(
      (societe: Societe) =>
        !societe.societe0 &&
        (societe.raisonSociale
          .toUpperCase()
          .includes(this.search.toUpperCase()) ||
          societe.restaurantId === parseInt(this.search) ||
          (societe.codeImplant &&
            societe.codeImplant
              .toUpperCase()
              .includes(this.search.toUpperCase()))) &&
        (this.client !== "TOTAL" || societe.codeImplant !== undefined)
    );

    socs.sort((u1: Societe, u2: Societe) => {
      if (this.client !== "TOTAL") {
        if (u1.raisonSociale > u2.raisonSociale) {
          return 1;
        }
        if (u1.raisonSociale < u2.raisonSociale) {
          return -1;
        }
      } else if (u1.codeImplant && u2.codeImplant) {
        if (u1.codeImplant > u2.codeImplant) {
          return 1;
        }
        if (u1.codeImplant < u2.codeImplant) {
          return -1;
        }
      }

      return 0;
    });

    console.log("getFilteredSocietes done");
    return socs;
  }

  public selectSociete(societe: Societe) {
    this.selectedSociete = societe;
  }

  public addSociete(site: any) {
    if (site.clicked) {
      return; // Si le bouton est déjà cliqué, ne rien faire afin d'éviter les doublons
    }

    site.clicked = true;

    this.$store
      .dispatch("config/addSociete", {
        raisonSociale: site.libelle,
        restaurantId: site.restaurantId,
      })
      .then(
        (response: any) => {
          // console.log(response);
          this.setSuccess(site.libelle + " " + this.$t("added").toString());
          this.filteredSocieties = this.getFilteredSocietes();
        },
        (error: any) => {
          this.setErrorFromTxt(error.toString());
          this.$store.dispatch("login/setLoading", false);
        }
      );
  }

  public removeSoc(societeToRem: Societe) {
    this.$store.dispatch("config/removeSociete", societeToRem).then(
      (response: any) => {
        this.selectedSociete = new Societe();
        this.setSuccess(this.$t("ModifSaved").toString());
        this.setSuccess(
          societeToRem.raisonSociale + " " + this.$t("deleted").toString()
        );
        this.filteredSocieties = this.getFilteredSocietes();
      },
      (error: any) => {
        this.setErrorFromTxt(error.toString());
        this.$store.dispatch("login/setLoading", false);
      }
    );
  }

  @Watch("societes", { immediate: true })
  @Watch("search", { immediate: true })
  public onPropertyChanged(value: any, oldValue: any) {
    this.filteredSocieties = this.getFilteredSocietes();
  }

  public compareSite(societes: any) {
    let societesNames: any;
    if (this.client !== "TOTAL") {
      societesNames = societes.map((societe: any) => {
        return societe.restaurantId;
      });
    } else {
      societesNames = societes.map((societe: any) => {
        return societe.codeImplant;
      });
    }

    societesNames = _.orderBy(societesNames);
    let aCreer: any;
    if (this.client !== "TOTAL") {
      aCreer = this.sites.filter((site: Site) => {
        return societesNames.indexOf(site.restaurantId) === -1;
      });
    } else {
      aCreer = this.sites.filter((site: Site) => {
        return societesNames.indexOf(site.extras.code_implant) === -1;
      });
    }
    this.$store.dispatch("config/setSocieteACreer", aCreer);
    // this.societesToUpdate = new Array();
    /** A supprimer, utilisé pour gerer la creation du restaurantid sur les sociétés  */
    /*this.societesToUpdate = societes.filter((societe: any) => {
      const site = this.sites.find(
        (msite: Site) => msite.libelle === societe.raisonSociale && msite.restaurantId === societe.restaurantId
      );
      if (site) {
        societe.restaurantId = site.restaurantId;
        return societe;
      }
    });*/
    // console.log(societes);
  }

  public extract() {
    let societeJson = new Array();
    societeJson = this.societes.map((soc: any) => {
      return this.transformSoc(soc);
    });
    return societeJson;
  }

  private transformSoc(societe: Societe) {
    const obj: { [k: string]: any } = {
      raisonSociale: societe.raisonSociale,
      id: societe.restaurantId,
      uuid: societe.id,
    };

    return obj;
  }

  get client(): string {
    return this.$store.getters["getClient"];
  }

  get sites(): any {
    return this.$store.getters["login/sites"];
  }

  get societes(): Societe[] {
    return this.$store.getters["config/societes"];
  }

  get enseignes(): any {
    return this.$store.getters["login/enseignes"];
  }

  get societesACreer(): [] {
    const aCreer = this.$store.getters["config/societesACreer"];
    aCreer.forEach((objet: { clicked: boolean }) => {
      objet.clicked = false;
    });
    return aCreer;
  }
}
